import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

// Dummy reducer to satisfy combineReducers
const initialState = {};
function reducer(state = initialState, _action = {}) {
  return state;
}

export default reducer;

export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

export const loadData = (_params, _search) => dispatch => {
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };
  return dispatch(fetchPageAssets(pageAsset, true));
};
